import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const facilitiesQueryAtom = createQueryAtomFactory(
  'production.facilities',
  () => ({
    facilities: {
      __args: {
        pagination: { limit: 1000, offset: 0 },
      },
      entries: {
        id: true,
        facilityName: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data) => ({
      facilities:
        data?.facilities?.entries?.map((f) => ({
          id: f.id,
          name: f.facilityName,
        })) ?? [],
    }),
  },
);
